module.exports = __webpack_public_path__ + "img/homme.2c8b1723.png";